import apiFetch from '../../apiFetch'

export default function (idVerraco, token) {
  return apiFetch({endPoint: `FichaVerraco/getHistoricoEstadosVerraco?idVerraco=` + idVerraco, method: 'GET', body: null, token: token})
}
